export * from './Avatar';
//# sourceMappingURL=index.js.map